import {getEndpoint, getHeaders} from "../../../helpers/endpoint";

export const fetchStatsUsersMPGTB = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('getUsersStatsMPGTB', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if (onSuccess) onSuccess(data, 'users');
        })
            .catch((error, type) => {
                if (onFail) onFail(type, error);
            });
    };
};

export const fetchStatsSupportersMPGTB = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('getSupportersStatsMPGTB', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if (onSuccess) onSuccess(data, 'supporters');
        })
            .catch((error, type) => {
                if (onFail) onFail(type, error);
            });
    };
};

export const fetchStatsWallMPGTB = (payload, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('getWallStatsMPGTB', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if (onSuccess) onSuccess(data, 'wall');
        })
            .catch((error, type) => {
                if (onFail) onFail(type, error);
            });
    };
};

export const fetchCommentsMPGTB = (onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        if (onRequest) onRequest();

        fetch(getEndpoint('getCommentsMPGTB'), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if (onSuccess) onSuccess(data);
        })
            .catch((error, type) => {
                if (onFail) onFail(type, error);
            });
    };
};

export const deleteCommentMPGTB = (commentId, onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        if (onRequest) onRequest(commentId);

        fetch(getEndpoint('deleteCommentMPGTB', commentId), {
            method: 'DELETE',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if (onSuccess) onSuccess(data);
        })
            .catch((error, type) => {
                if (onFail) onFail(type, error);
            });
    };
};

export const getRankingMPGTB = (onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        if (onRequest) onRequest();

        fetch(getEndpoint('getRankingMPGTB'), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if (onSuccess) onSuccess(data);
        })
            .catch((error, type) => {
                if (onFail) onFail(type, error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/mpgtb/users.js